import { Typography } from "@hellocarbo/lasagne";
import { Wind } from "lucide-react";

function CannotCalculateIntensityMessage({ message }: { message: string }) {
  return (
    <div className="my-lg gap-y-xs flex flex-col items-center">
      <Wind role="img" className="size-md text-grayscale" />
      <Typography className="text-grayscale max-w-2/3 text-center" step="-1">
        {message}
      </Typography>
    </div>
  );
}

export default CannotCalculateIntensityMessage;
